var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"close","d":"M21.476,1.147a.77.77,0,0,0-.2-.75,1.16,1.16,0,0,0-.682-.409.77.77,0,0,0-.75.2c-.068.068-.136.136-.2.136l-8.865,9L1.837.4A1,1,0,0,0,.405.193,1,1,0,0,0,.2,1.625c.068.068.136.136.136.2L9.27,10.762.337,19.7a1.055,1.055,0,0,0,.068,1.432.875.875,0,0,0,.682.273,1.43,1.43,0,0,0,.75-.273l8.933-8.933L19.7,21.127a1.026,1.026,0,0,0,.75.273,1.1,1.1,0,0,0,.75-.341,1.026,1.026,0,0,0,.273-.75,1.212,1.212,0,0,0-.273-.682l-9-8.865,8.865-8.933A1.16,1.16,0,0,0,21.476,1.147Z","transform":"translate(0.013 0.038)","fill":"#26b8ce"}));
}

Close.defaultProps = {"width":"21.514","height":"21.438","viewBox":"0 0 21.514 21.438"};

module.exports = Close;

Close.default = Close;
